import { LanguageTestSection } from '../../../lib/types/models/language-test/language-test-section'
import {
  LanguageTestTemplate,
  LanguageTestTemplateInput
} from '../../../lib/types/models/language-test/language-test-template'

export class LanguageTestProperties {
  static getQuestionsCount(sections: LanguageTestSection[]) {
    return sections.reduce((acc, section) => acc + section.questions.length, 0)
  }

  static mapLanguageTestTemplateToInput(
    template: LanguageTestTemplate
  ): LanguageTestTemplateInput {
    return {
      name: template.name,
      countries: template.countries.map((country) => country.id),
      formulas: template.formulas.map((formula) => formula.id)
    }
  }
}
